import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { IEvaluationContext } from "../IEvaluationContext";
import { IterationContext } from "../ModelPath/IterationContext";
import { InvalidProgramStateError } from "../../../../../../Common/Errors";

import { CalculationAction, CalculationActionDecorator, IExecutionPlanStep } from "./ExecutionPlanStep";

export class IterateOverChildrenPlanStep implements IExecutionPlanStep {
    private readonly pathToList: AbsoluteModelPath;
    private readonly sync?: boolean;
    private readonly instancesToIterate?: string[];

    public constructor(pathToList: AbsoluteModelPath, instancesToIterate?: string[], sync?: boolean) {
        this.sync = sync;
        this.pathToList = pathToList;
        this.instancesToIterate = instancesToIterate;
    }

    public getStepExecutor(): CalculationActionDecorator {
        return (this.sync ?? false)
            ? this.getSyncCalculationActionDecorator()
            : this.getAsyncCalculationActionDecorator();
    }

    private getAsyncCalculationActionDecorator() {
        const pathToList = this.pathToList;
        return (action: CalculationAction): CalculationAction =>
            async (context: IEvaluationContext): Promise<void> => {
                const instances = this.instancesToIterate ?? context.getInstances(pathToList) ?? [];
                for (const instance of instances) {
                    const newContext = context.pushIterationContext(new IterationContext(pathToList, instance));
                    await action(newContext);
                }
            };
    }

    private getSyncCalculationActionDecorator() {
        const pathToList = this.pathToList;
        return (action: CalculationAction): CalculationAction =>
            (context: IEvaluationContext): void => {
                const instances = this.instancesToIterate ?? context.getInstances(pathToList) ?? [];
                for (const instance of instances) {
                    const newContext = context.pushIterationContext(new IterationContext(pathToList, instance));
                    const result = action(newContext);
                    if (result != undefined) {
                        throw new InvalidProgramStateError();
                    }
                }
            };
    }

    public toDebugString(): string {
        return `iterate(${this.pathToList.toString()})`;
    }
}
